import React from 'react';
import { AllocationResult } from '../../types';
import './AllocationVisualization.css';

interface AllocationVisualizationProps {
  allocations: AllocationResult[];
  nodeNameMap: Map<string, string>;
}

const AllocationVisualization: React.FC<AllocationVisualizationProps> = ({ allocations, nodeNameMap }) => {
  const formatNumber = (num: number): string => {
    return new Intl.NumberFormat().format(Math.round(num * 100) / 100);
  };

  const getNodeDisplayName = (nodeId: string): string => {
    const nodeName = nodeNameMap.get(nodeId);
    return nodeName || nodeId;
  };

  const nodesReceivingInventory = allocations.filter(allocation => allocation.allocated_quantity > 0);
  const totalAllocated = allocations.reduce((sum, allocation) => sum + allocation.allocated_quantity, 0);

  return (
    <div className="allocation-visualization">
      <h4>Allocation Summary</h4>
      <div className="allocation-summary">
        <div className="summary-stats">
          <div className="stat">
            <span className="stat-value">{nodesReceivingInventory.length}</span>
            <span className="stat-label">Nodes Receiving Inventory</span>
          </div>
          <div className="stat">
            <span className="stat-value">{formatNumber(totalAllocated)}</span>
            <span className="stat-label">Total Allocated</span>
          </div>
          <div className="stat">
            <span className="stat-value">{allocations.length}</span>
            <span className="stat-label">Total Nodes</span>
          </div>
        </div>
      </div>
      
      {nodesReceivingInventory.length > 0 && (
        <div className="receiving-nodes">
          <h5>Nodes Receiving Inventory</h5>
          <div className="nodes-list">
            {nodesReceivingInventory.map((allocation) => (
              <div key={allocation.node_id} className="node-item">
                <span className="node-name">{getNodeDisplayName(allocation.node_id)}</span>
                <span className="allocation-amount">{formatNumber(allocation.allocated_quantity)} units</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AllocationVisualization;